import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import AdUnit from '../ads/AdUnit';
import { getQuizById } from '../data/quizRegistry';
import '../styles/resultLoading.css';

const LOADING_STEPS = [
  '답변 분석 중...',
  '건강 데이터 비교 중...',
  '결과 계산 중...',
  '리포트 생성 중...',
];

const ResultLoadingPage: React.FC = () => {
  const { quizId } = useParams<{ quizId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const [stepIndex, setStepIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  const quiz = quizId ? getQuizById(quizId) : null;

  useEffect(() => {
    if (!location.state?.score && location.state?.score !== 0) {
      navigate('/', { replace: true });
      return;
    }

    const stepInterval = setInterval(() => {
      setStepIndex((prev) => {
        if (prev < LOADING_STEPS.length - 1) return prev + 1;
        return prev;
      });
    }, 1000);

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) return 100;
        return prev + 2.5;
      });
    }, 100);

    const timer = setTimeout(() => {
      navigate(`/quiz/${quizId}/result`, {
        state: location.state,
        replace: true,
      });
    }, 4000);

    return () => {
      clearInterval(stepInterval);
      clearInterval(progressInterval);
      clearTimeout(timer);
    };
  }, [navigate, quizId, location.state]);

  const gradientStart = quiz?.gradient[0] || '#E8B4F8';
  const gradientEnd = quiz?.gradient[1] || '#C9A0DC';

  return (
    <div className="loading-wrapper">
      <div className="loading-container">
        <div
          className="loading-spinner"
          style={{ borderTopColor: gradientEnd }}
        />
        <div className="loading-text">{LOADING_STEPS[stepIndex]}</div>
        <div className="loading-subtext">
          {quiz ? quiz.title : '건강 테스트'} 결과를 준비하고 있어요
        </div>
        <div className="loading-progress-bar">
          <div
            className="loading-progress-fill"
            style={{
              width: `${progress}%`,
              background: `linear-gradient(90deg, ${gradientStart}, ${gradientEnd})`,
            }}
          />
        </div>

        <AdUnit format="inarticle" slot="4321660013" />
      </div>
    </div>
  );
};

export default ResultLoadingPage;
